import React from 'react'
import './pageoverLay.css'

const PageOverlay = () => {
    return (
        <div className="submit-bg" id="pageoverlay">
            <div className='copying'>
                <div className="page-loader">
                  <div className="page-loader-spinner"><img src='/assets/images/rhybusicon.png' alt="loader" /> </div>
                  <div>Loading...</div>
              </div>
            </div>   
          </div>
    )
}

export default PageOverlay
